import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';
import styled from 'styled-components';
import ds from 'designsystem';

const CheckboxWrapper = styled.div`
  margin-top: ${({ marginTop }) => marginTop};
`;

const StyledLabel = styled.label`
  display: flex;
  position: relative;
  cursor: pointer;
`;

const CheckboxInput = styled.input`
  display: block;
  transform: scale(2);
  margin-right: ${ds.get('metrics.value')};
  position: absolute;
  z-index:-1;
  left:15px;
  top:10px;
  opacity: 0;
`;

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    bottom:0;
    height:2px;
    width:100%;
    background-image: radial-gradient(${ds.brand('text')} 2px, ${ds.brand('white')} 2px);
    background-size: 5px 10px;
    opacity: 0.55;
  }
  &:after {
    content: '';
    position: absolute;
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    left: 9px;
    top: 0;
    width: 8px;
    height: 17px;
    border: solid blue;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
    }
  `;

const CheckboxText = styled.span`
  display: block;
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('text')};
  font-size: ${ds.fs('s')};
  font-weight: ${ds.get('type.fontWeight.light')};
  opacity: 0.8;
  margin-left:40px;
  & > p {
      margin: 0;
      & > a {
          color: ${ds.brand('text')};
          text-decoration: none;
          &:hover {
              color: ${ds.brand('productHover')};
          }
      }
  }`;

class CustomCheckbox extends Component {
    state = {
      checked: false,
    };

    componentDidUpdate(prevProps) {
      const { resetValue } = this.props;
      if (prevProps.resetValue !== resetValue) {
        this.setState({
          checked: false,
        });
      }
    }

    @Bind()
    handleInputChange(event) {
      const { target } = event;
      const { name } = target;
      const { getValue } = this.props;

      this.setState({
        checked: target.checked,
      });

      getValue({
        inputName: name,
        value: target.checked,
      });
    }

    render() {
      const {
        checked,
      } = this.state;

      const {
        name,
        checkboxText,
        required,
        marginTop,
      } = this.props;

      return (
        <CheckboxWrapper marginTop={marginTop}>
          <StyledLabel>
            <CheckboxInput
              type="checkbox"
              required={required}
              name={name}
              checked={checked}
              onChange={this.handleInputChange}
            />
            <Checkmark checked={checked} />
            <CheckboxText dangerouslySetInnerHTML={{
              __html: checkboxText,
            }}
            />
          </StyledLabel>
        </CheckboxWrapper>
      );
    }
}

export default CustomCheckbox;

CustomCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  checkboxText: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  required: PropTypes.bool,
  resetValue: PropTypes.bool,
  marginTop: PropTypes.string,
};
CustomCheckbox.defaultProps = {
  required: false,
  resetValue: false,
  getValue: () => {},
  marginTop: '0',
};



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomCheckbox.jsx